<div class="funnel-shell">
  @if (languages().length > 1) {
    <div class="funnel-shell__lang-switch">
      <button
        type="button"
        class="funnel-shell__lang-btn funnel-shell__lang-toggle"
        aria-haspopup="listbox"
        [attr.aria-expanded]="langOpen()"
        (click)="toggleLangMenu($event)"
      >{{ currentLang().toUpperCase() }}<span class="caret">▼</span></button>

      @if (langOpen()) {
        <div class="funnel-shell__lang-menu" role="listbox">
          @for (lang of languages(); track lang.code) {
            <button
              type="button"
              role="option"
              class="funnel-shell__lang-item"
              [class.is-active]="lang.code === currentLang()"
              [attr.aria-selected]="lang.code === currentLang()"
              (click)="switchLanguage(lang.code)"
            >
              <span>{{ lang.name }}</span>
              <span class="code">{{ lang.label }}</span>
            </button>
          }
        </div>
      }
    </div>
  }

  <div class="funnel-shell__content">
    <ng-content />
  </div>

  <div class="funnel-shell__legal">
    <a class="funnel-shell__legal-link" (click)="openPolicy('privacy')">
      {{ 'policy.privacy' | translate }}
    </a>
    <a class="funnel-shell__legal-link" (click)="openPolicy('terms')">
      {{ 'policy.tos' | translate }}
    </a>
    <a class="funnel-shell__legal-link" (click)="openPolicy('imprint')">
      {{ 'policy.legalNotice' | translate }}
    </a>
  </div>

  @if (footerText(); as footerText) {
    <div class="funnel-shell__operator">
      <span [innerHtml]="footerText | safeHtml"></span>
    </div>
  }
</div>

<c-offcanvas
  placement="end"
  [visible]="policyVisible()"
  (visibleChange)="policyVisibleChange($event)"
>
  <c-offcanvas-header>
    <button
      type="button"
      class="btn-close ms-auto"
      aria-label="Close"
      (click)="closePolicy()"
    ></button>
  </c-offcanvas-header>
  <c-offcanvas-body>
    @if (policyLoading()) {
      <p>Loading…</p>
    } @else {
      <consent [content]="policyContent()"></consent>
    }
  </c-offcanvas-body>
</c-offcanvas>
